import moment from "moment/moment";
import { useEffect, useState } from "react";

 export const convertUTCToLocalTime = (
    end_date,
    end_time,
    format = "DD MMM YYYY hh:mm a"
  ) => {
    const utcDateTime = moment.utc(
      `${end_date} ${end_time}`,
      "YYYY-MM-DD HH:mm:ss"
    );
    const localDateTime = utcDateTime.local();
    return localDateTime.format(format);
  };

  export const useIsMobile = (breakpoint = 1024) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);
  
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < breakpoint);
      };
  
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);
  
    return isMobile;
  };